import React from 'react';
import { Link, useParams } from 'react-router-dom';

import Dashboard from '~/layouts/Dashboard';
import { ClientFormData } from './ClientFormData';
import { ClientFormModal } from './ClientFormModal';

interface Params {
  id: string;
}

const ClientForm: React.FC = () => {
  const params = useParams<Params>();
  const { id } = params;

  return (
    <Dashboard containerMessage="col-xl-6 offset-xl-3 col-md-10 offset-md-1">
      <div className="row">
        <div className="col-xl-6 offset-xl-3 col-md-10 offset-md-1">
          <div className="nk-block nk-block-lg">
            <div className="nk-block-head">
              <div className="nk-block-head-content">
                <div className="nk-block-head-sub">
                  <Link className="back-to" to="/clients">
                    <em className="icon ni ni-arrow-left" />
                    <span>Voltar</span>
                  </Link>
                </div>
                <h4 className="title nk-block-title">
                  {id ? 'Editar Cliente' : 'Cadastrar Cliente'}
                </h4>
                <div className="nk-block-des">
                  <p>
                    Preencha o formulário abaixo e cadastre um novo cliente.
                  </p>
                </div>
              </div>
            </div>
            <div className="card card-bordered">
              <div className="card-inner">
                <ClientFormData id={id} redirect="/clients" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default ClientForm;
